export default function wpAccordion() {
    /*==============
    Accordion
    ==============*/
    let accordionSelector = ".wp-accordion .wp-block-heading";
    // Show first Element
    if (document.querySelector(accordionSelector)) {
        console.log('Accordion gefunden.',accordionSelector)
        let firstPanel = document.querySelector(accordionSelector).nextElementSibling;
        let firstHeading = document.querySelector(accordionSelector);
        firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
        firstHeading.classList.add('active');
        firstPanel.classList.add('active');
        if (!firstHeading) {
            console.log('no first heading');
        }
        [...document.querySelectorAll(accordionSelector)].forEach(accordion => {
            // add class name to heading for further adjustment
            accordion.classList.add("accordion-heading");
            accordion.nextElementSibling.classList.add("accordion-panel");

            accordion.addEventListener("click", function() {
                var panel = this.nextElementSibling;
                panel.style.maxHeight = panel.style.maxHeight ? null : panel.scrollHeight + "px";
                if (this.classList.contains('active')) {
                    this.classList.remove('active');
                    panel.classList.remove('active');
                } else {
                    this.classList.add('active');
                    panel.classList.add('active');
                }
            })
        })
    }
}
